import dayjs from "dayjs";
import { DATE_FORMAT } from "./constants";

export const convertDayjsToFormat = (value: unknown, format: string = DATE_FORMAT): unknown => {
  if (dayjs.isDayjs(value)) {
    return value.format(format);
  }

  if (Array.isArray(value)) {
    return value.map((v) => convertDayjsToFormat(v, format));
  }

  if (value !== null && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, convertDayjsToFormat(val, format)]));
  }

  return value;
};
